/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var RowRange = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(RowRange, _super);
    function RowRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.f = 0;
        _this.d = 0;
        return _this;
    }
    Object.defineProperty(RowRange.prototype, "e", {
        get: function () {
            return (this.d - this.f) + 1;
        },
        enumerable: true,
        configurable: true
    });
    RowRange.prototype.c = function (a) {
        return a.f >= this.f && a.f <= this.d || a.d >= this.f && a.d <= this.d;
    };
    RowRange.prototype.b = function (a) {
        return a >= this.f && a <= this.d;
    };
    RowRange.a = function (a, b) {
        for (var c = 0; c < a.count; c++) {
            if (a._inner[c].b(b)) {
                return a._inner[c];
            }
        }
        return null;
    };
    RowRange.$t = markType(RowRange, 'RowRange');
    return RowRange;
}(Base));
export { RowRange };
//# sourceMappingURL=RowRange.js.map
